/**
 * Lectures Limits Cell - Frontend
 * @description Cell component for displaying limits in LecturesTable
 */

import React from 'react';
import { CellContext } from '@tanstack/react-table';
import { LecturesTableData } from '@/types/operational-ui.types';

interface LecturesSingleLimitCellProps {
  info: CellContext<LecturesTableData, number>;
}

export const LecturesSingleLimitCell: React.FC<LecturesSingleLimitCellProps> = ({ info }) => {
  const value = info.getValue();
  // const row = info.row.original;

  return (
    <div className="text-sm text-center">
      <div className="text-gray-900">{value.toFixed(2)}</div>
    </div>
  );
};
